import { useSelector } from "react-redux"
import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import NavBar from "../components/navbar";
import Footer from "../components/footer";
import Contact from "../components/contact";
import Hero from "./components/hero";
import TriCards from "./components/triCards";
import BeforeAfter from "./components/beforeAfter";
import PageShell from "../components/pageShell"
import ZigZag from "./components/zigzag";
import { ButtonGroup } from "../components/basicUIComponents";
import { MetaTagHandler } from "../../../library/client/serverCallHandler";

const MonumentPage = () => {

    return (
        <>
            <MetaTagHandler>
                {() => (
                    <>
                        <title>Window Cleaning - Flyby Shine</title>
                        <meta name="description" content="Utilizing state-of-the-art drone technology or traditional methods, we offer safe, efficient, and thorough cleaning solutions." />
                        <meta name="keywords" content="Window Cleaning, Window cleaning services, commercial window cleaning, industrial window cleaning, hygienic window cleaning, expert window cleaning services, safe window cleaning, thorough window cleaning, professional window cleaning, reliable window cleaning, top-quality window cleaning, window cleaning services, window cleaning solutions, window cleaning experts" />
                        <meta property="og:image" content="/assets/window.png" />
                    </>
                )}
            </MetaTagHandler>

            <PageShell>
                <Hero
                    subTitle={'Commercial & Industrial'}
                    title={'Drone Monument Restoration'}
                    description={`Utilizing state-of-the-art drone technology or traditional methods, we offer safe, efficient, and thorough cleaning solutions. `}
                    banner={{
                        video: '/assets/videos/monument.mp4',
                        thumbnail: '/assets/videos/thumbnails/monument.png'
                    }}
                    callToAction={
                        <ButtonGroup>
                            <ButtonGroup.Button to={'/contact'} text={'Book A Time'} />
                            <ButtonGroup.Button to={'/commercial-industrial'} text={'All Services'} />
                        </ButtonGroup>
                    }

                />
                <TriCards>
                    <TriCards.Card
                        title={'Reach High Areas Safely'}
                        heading={{ image: '/assets/upwardIcon.svg', alt: 'about' }}
                        description={'With our state-of-the-art drone technology, we offer safe, efficient, and thorough cleaning solutions for monuments.'}

                    />
                    <TriCards.Card
                        title={'FAA Licensed Pilots'}
                        heading={{ image: '/assets/checkmark.svg', alt: 'about' }}
                        description={'Our team of FAA-licensed pilots brings exceptional expertise and reliability, ensuring top safety and quality standards in every project.'}
                    />
                    <TriCards.Card
                        title={'Faster Cleanings'}
                        heading={{ image: '/assets/boltIcon.svg', alt: 'about' }}
                        description={'Drones can clean large surface areas much faster than traditional methods, reducing the cleaning time.'}
                    />
                </TriCards>
                <ZigZag>

                    <ZigZag.Card
                        largeGraphic={{ image: '/assets/drone2a.png', alt: 'drone displayed' }}
                        title={'Customized Approach'}
                        heading={{ image: '/assets/flexible.svg', alt: 'flexibility about us icon' }}
                        description={'Our drones offer the flexibility to adapt to various surfaces and architectural styles, whether it’s high-rise office buildings, complex industrial sites, or delicate historical structures. We customize our approach to fit your specific requirements, ensuring optimal results for every job.'}
                    />
                    <ZigZag.Card
                        largeGraphic={{
                            video: '/assets/videos/windowclean.mp4',
                            thumbnail: '/assets/videos/thumbnails/windowclean.png'

                        }}
                        title={'Advanced Drone Technology'}
                        heading={{ image: '/assets/water.svg', alt: 'water icon' }}
                        description={'Our advanced drone technology allows us to reach high areas safely and efficiently, providing a thorough cleaning solution for monuments and historical structures.'}
                    />
                </ZigZag>

                <Contact />
            </PageShell>


        </>
    )
}

export default MonumentPage
